import styles from "./rendimentiCumulatiPerHoldingPeriodLegend.module.scss";
import { memo } from "react";
import {
  BottomWhiskerSvg,
  TopWhiskerSvg,
  AverageSvg,
  MedianSvg,
  Svg25PercentSvg,
  Svg75PercentSvg,
} from "shared/assets/svg/graphs-legend-icons";

interface RendimentiCumulatiPerHoldingPeriodLegendProps {}

const RendimentiCumulatiPerHoldingPeriodLegend: React.FC<
  RendimentiCumulatiPerHoldingPeriodLegendProps
> = () => {
  const legendItemSymbolViewBox = "0 0 33 33";

  return (
    <div className={styles.legendContainer}>
      <div className={styles.legendItems}>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <TopWhiskerSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>Max</div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <BottomWhiskerSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>Min</div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <MedianSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>Mediana</div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <AverageSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>Media</div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <Svg25PercentSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>25° pct</div>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendItemSymbol}>
            <Svg75PercentSvg viewBox={legendItemSymbolViewBox} />
          </div>
          <div className={styles.legendItemLabel}>75° pct</div>
        </div>
      </div>
    </div>
  );
};

export default memo(RendimentiCumulatiPerHoldingPeriodLegend);
